module.exports = __webpack_public_path__ + "media/images/products/retailers-customised-1-hero-0c12503fcd939dbb69a2a96f110b872c.jpg";